$(document).ready(function () {
   // View more button
function toggleDescription() {
        var descriptionContent = $('#descriptionContent');
        var viewMoreBtn = $('#viewMoreBtn');

        // Toggle the expanded class
        descriptionContent.toggleClass('expanded');

        // Change button text based on state
        if (descriptionContent.hasClass('expanded')) {
            viewMoreBtn.text('View Less');
        } else {
            viewMoreBtn.text('View More');
        }
    }

    // Attach the toggle function to the button click event
    $('#viewMoreBtn').on('click', toggleDescription);






  
   // Video Gallery Slider
  $(".video-row").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.35,
          slidesToScroll: 1,
          arrows: false,
          infinite: false,
        },
      },
    ],
  });


  
   // Ingredients Slider
  function initializeSlick() {
    if ($(window).width() <= 1024) { // Only initialize on mobile screens
      if (!$(".ingredients-sec .m-custom-content__wrapper").hasClass("slick-initialized")) {
        $(".ingredients-sec .m-custom-content__wrapper").slick({
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1.13,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
              },
            },
          ],
        });
      }
    } else {
      if ($(".ingredients-sec .m-custom-content__wrapper").hasClass("slick-initialized")) {
        $(".ingredients-sec .m-custom-content__wrapper").slick("unslick"); // Destroy Slick on larger screens
      }
    }
  }

  // Initialize on document ready
  initializeSlick();

  // Re-check on window resize
  $(window).resize(function () {
    initializeSlick();
  });

  
})